module.exports = __webpack_public_path__ + "static/img-paralax-e20f6a0137b633109dbc1336a048ef58.jpg";